import CryptoJS from 'crypto-js';

class SecurityUtils {
    static generateNonce() {
        return Math.random().toString(36).substring(2, 15) +
            Math.random().toString(36).substring(2, 15);
    }

    static generateSignature(method, path, queryString = '', timestamp, nonce) {
        // IMPORTANT: This must match the backend SECRET_SALT
        const SECRET_SALT = 'zakovat-2025-secret-salt';

        const data = `${method}:${path}:${queryString}:${timestamp}:${nonce}:${SECRET_SALT}`;

        // Use SHA-256 hash
        const hash = CryptoJS.SHA256(data);
        return CryptoJS.enc.Base64.stringify(hash);
    }

    static getSecurityHeaders(method, url) {
        const timestamp = Date.now().toString();
        const nonce = this.generateNonce();

        // Parse URL to get path and query
        const urlObj = new URL(url);
        const path = urlObj.pathname;
        const queryString = urlObj.search ? urlObj.search.substring(1) : '';

        const signature = this.generateSignature(
            method,
            path,
            queryString,
            timestamp,
            nonce
        );

        return {
            'X-Request-Signature': signature,
            'X-Request-Timestamp': timestamp,
            'X-Nonce': nonce
        };
    }

    // Method to wrap existing fetch calls with security headers
    static async secureFetch(url, options = {}) {
        const securityHeaders = this.getSecurityHeaders(
            options.method || 'GET',
            url
        );

        const config = {
            ...options,
            credentials: 'include',
            headers: {
                ...options.headers,
                ...securityHeaders,
                'Content-Type': 'application/json',
            }
        };

        const response = await fetch(url, config);

        if (!response.ok) {
            if (response.status === 403) {
                throw new Error('Access denied - invalid request signature');
            }
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response;
    }
}

export default SecurityUtils;
